/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceManagementAlertDashboardBlockReport', 'model/PerformanceManagementAlertIndicator', 'model/PerformanceManagementAlertRecipient', 'model/PerformanceManagementAlertReviewSectionReport', 'model/PerformanceManagementAlertTriggerIndicator'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PerformanceManagementAlertDashboardBlockReport'), require('./PerformanceManagementAlertIndicator'), require('./PerformanceManagementAlertRecipient'), require('./PerformanceManagementAlertReviewSectionReport'), require('./PerformanceManagementAlertTriggerIndicator'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceManagementAlertReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceManagementAlertDashboardBlockReport, root.ForStractionServiceApi.PerformanceManagementAlertIndicator, root.ForStractionServiceApi.PerformanceManagementAlertRecipient, root.ForStractionServiceApi.PerformanceManagementAlertReviewSectionReport, root.ForStractionServiceApi.PerformanceManagementAlertTriggerIndicator);
  }
}(this, function(ApiClient, PerformanceManagementAlertDashboardBlockReport, PerformanceManagementAlertIndicator, PerformanceManagementAlertRecipient, PerformanceManagementAlertReviewSectionReport, PerformanceManagementAlertTriggerIndicator) {
  'use strict';




  /**
   * The PerformanceManagementAlertReport model module.
   * @module model/PerformanceManagementAlertReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceManagementAlertReport</code>.
   * @alias module:model/PerformanceManagementAlertReport
   * @class
   */
  var exports = function() {
    var _this = this;




































  };

  /**
   * Constructs a <code>PerformanceManagementAlertReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceManagementAlertReport} obj Optional instance to populate.
   * @return {module:model/PerformanceManagementAlertReport} The populated <code>PerformanceManagementAlertReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Recipients')) {
        obj['Recipients'] = ApiClient.convertToType(data['Recipients'], [PerformanceManagementAlertRecipient]);
      }
      if (data.hasOwnProperty('TriggerIndicators')) {
        obj['TriggerIndicators'] = ApiClient.convertToType(data['TriggerIndicators'], [PerformanceManagementAlertTriggerIndicator]);
      }
      if (data.hasOwnProperty('Indicators')) {
        obj['Indicators'] = ApiClient.convertToType(data['Indicators'], [PerformanceManagementAlertIndicator]);
      }
      if (data.hasOwnProperty('Sections')) {
        obj['Sections'] = ApiClient.convertToType(data['Sections'], [PerformanceManagementAlertReviewSectionReport]);
      }
      if (data.hasOwnProperty('Blocks')) {
        obj['Blocks'] = ApiClient.convertToType(data['Blocks'], [PerformanceManagementAlertDashboardBlockReport]);
      }
      if (data.hasOwnProperty('LastSent')) {
        obj['LastSent'] = ApiClient.convertToType(data['LastSent'], 'Date');
      }
      if (data.hasOwnProperty('EvaluationVisible')) {
        obj['EvaluationVisible'] = ApiClient.convertToType(data['EvaluationVisible'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('DeliveryChannelID')) {
        obj['DeliveryChannelID'] = ApiClient.convertToType(data['DeliveryChannelID'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerTypeID')) {
        obj['TriggerTypeID'] = ApiClient.convertToType(data['TriggerTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerTimePeriodTypeID')) {
        obj['TriggerTimePeriodTypeID'] = ApiClient.convertToType(data['TriggerTimePeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ActivityStatusID')) {
        obj['ActivityStatusID'] = ApiClient.convertToType(data['ActivityStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('CoverLetterText')) {
        obj['CoverLetterText'] = ApiClient.convertToType(data['CoverLetterText'], 'String');
      }
      if (data.hasOwnProperty('SendPreviewForAnalysis')) {
        obj['SendPreviewForAnalysis'] = ApiClient.convertToType(data['SendPreviewForAnalysis'], 'Boolean');
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('RedirectToHomePage')) {
        obj['RedirectToHomePage'] = ApiClient.convertToType(data['RedirectToHomePage'], 'Boolean');
      }
      if (data.hasOwnProperty('AgendaFunctionID')) {
        obj['AgendaFunctionID'] = ApiClient.convertToType(data['AgendaFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('TriggerIndicatorStartDateTypeID')) {
        obj['TriggerIndicatorStartDateTypeID'] = ApiClient.convertToType(data['TriggerIndicatorStartDateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorStartDateMonthOffset')) {
        obj['TriggerIndicatorStartDateMonthOffset'] = ApiClient.convertToType(data['TriggerIndicatorStartDateMonthOffset'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorNowDateTypeID')) {
        obj['TriggerIndicatorNowDateTypeID'] = ApiClient.convertToType(data['TriggerIndicatorNowDateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorNowDateMonthOffset')) {
        obj['TriggerIndicatorNowDateMonthOffset'] = ApiClient.convertToType(data['TriggerIndicatorNowDateMonthOffset'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorEndDateTypeID')) {
        obj['TriggerIndicatorEndDateTypeID'] = ApiClient.convertToType(data['TriggerIndicatorEndDateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorEndDateMonthOffset')) {
        obj['TriggerIndicatorEndDateMonthOffset'] = ApiClient.convertToType(data['TriggerIndicatorEndDateMonthOffset'], 'Integer');
      }
      if (data.hasOwnProperty('TriggerIndicatorBudgetUseLimit')) {
        obj['TriggerIndicatorBudgetUseLimit'] = ApiClient.convertToType(data['TriggerIndicatorBudgetUseLimit'], 'Number');
      }
      if (data.hasOwnProperty('EmailTitleType')) {
        obj['EmailTitleType'] = ApiClient.convertToType(data['EmailTitleType'], 'Integer');
      }
      if (data.hasOwnProperty('CustomEmailTitle')) {
        obj['CustomEmailTitle'] = ApiClient.convertToType(data['CustomEmailTitle'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TemplateID')) {
        obj['TemplateID'] = ApiClient.convertToType(data['TemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('SentToReview')) {
        obj['SentToReview'] = ApiClient.convertToType(data['SentToReview'], 'Date');
      }
      if (data.hasOwnProperty('SentToRecipients')) {
        obj['SentToRecipients'] = ApiClient.convertToType(data['SentToRecipients'], 'Date');
      }
      if (data.hasOwnProperty('CustomTargetPeriod')) {
        obj['CustomTargetPeriod'] = ApiClient.convertToType(data['CustomTargetPeriod'], 'Date');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/PerformanceManagementAlertRecipient>} Recipients
   */
  exports.prototype['Recipients'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceManagementAlertTriggerIndicator>} TriggerIndicators
   */
  exports.prototype['TriggerIndicators'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceManagementAlertIndicator>} Indicators
   */
  exports.prototype['Indicators'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceManagementAlertReviewSectionReport>} Sections
   */
  exports.prototype['Sections'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceManagementAlertDashboardBlockReport>} Blocks
   */
  exports.prototype['Blocks'] = undefined;
  /**
   * @member {Date} LastSent
   */
  exports.prototype['LastSent'] = undefined;
  /**
   * @member {Boolean} EvaluationVisible
   * @default false
   */
  exports.prototype['EvaluationVisible'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} DeliveryChannelID
   * @default 0
   */
  exports.prototype['DeliveryChannelID'] = 0;
  /**
   * @member {Integer} TriggerTypeID
   */
  exports.prototype['TriggerTypeID'] = undefined;
  /**
   * @member {Integer} TriggerTimePeriodTypeID
   */
  exports.prototype['TriggerTimePeriodTypeID'] = undefined;
  /**
   * @member {Integer} ActivityStatusID
   * @default 0
   */
  exports.prototype['ActivityStatusID'] = 0;
  /**
   * @member {String} CoverLetterText
   * @default ''
   */
  exports.prototype['CoverLetterText'] = '';
  /**
   * @member {Boolean} SendPreviewForAnalysis
   * @default false
   */
  exports.prototype['SendPreviewForAnalysis'] = false;
  /**
   * @member {Integer} ResponsibleUserID
   */
  exports.prototype['ResponsibleUserID'] = undefined;
  /**
   * @member {Boolean} RedirectToHomePage
   * @default false
   */
  exports.prototype['RedirectToHomePage'] = false;
  /**
   * @member {Integer} AgendaFunctionID
   */
  exports.prototype['AgendaFunctionID'] = undefined;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorStartDateTypeID
   */
  exports.prototype['TriggerIndicatorStartDateTypeID'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorStartDateMonthOffset
   */
  exports.prototype['TriggerIndicatorStartDateMonthOffset'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorNowDateTypeID
   */
  exports.prototype['TriggerIndicatorNowDateTypeID'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorNowDateMonthOffset
   */
  exports.prototype['TriggerIndicatorNowDateMonthOffset'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorEndDateTypeID
   */
  exports.prototype['TriggerIndicatorEndDateTypeID'] = undefined;
  /**
   * @member {Integer} TriggerIndicatorEndDateMonthOffset
   */
  exports.prototype['TriggerIndicatorEndDateMonthOffset'] = undefined;
  /**
   * @member {Number} TriggerIndicatorBudgetUseLimit
   */
  exports.prototype['TriggerIndicatorBudgetUseLimit'] = undefined;
  /**
   * @member {Integer} EmailTitleType
   * @default 0
   */
  exports.prototype['EmailTitleType'] = 0;
  /**
   * @member {String} CustomEmailTitle
   * @default ''
   */
  exports.prototype['CustomEmailTitle'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} TemplateID
   */
  exports.prototype['TemplateID'] = undefined;
  /**
   * @member {Date} SentToReview
   */
  exports.prototype['SentToReview'] = undefined;
  /**
   * @member {Date} SentToRecipients
   */
  exports.prototype['SentToRecipients'] = undefined;
  /**
   * @member {Date} CustomTargetPeriod
   */
  exports.prototype['CustomTargetPeriod'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


